import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Utils from "../../../../commons/utils/utils";
import Http from "../../../../commons/utils/Http";
import ButtonAction from "../../../../commons/components/buttonAction";
import AccountTable from "../../../../commons/components/AccountTable";
import DataName from "./DataName";
import DataEmails from "./DataEmails";
import DataPartners from "./DataPartners";
import DataStatus from "./DataStatus";
import NewUserModal from "../NewUserModal/newUserModal";

import {
    usersSetSelectedUser,
    usersSetShowUsers,
    usersSetShowEditUser,
} from '../../../../store/actions/usersActions';

import Permissions from "../../../../commons/utils/permissions"

import { TableActions } from './cardUsersStyles';

function CardUsers(props) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { searchUser, filterPartner, filterApplication, showUserModal } = useSelector((state) => state.users);
    const [permissions] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);

    const defaultPagination = { current: 1, pageSize: 10 };
    const [pagination, setPagination] = useState(defaultPagination);

    const [sorter, setSorter] = useState({ field: "name", order: "ascend" });
    const [filters, setFilters] = useState({});

    const filterStatus = [
        {
            text: 'Ativo',
            value: 'ativo',
        },
        {
            text: 'Aguardando verificação',
            value: 'aguardando_verificacao',
        },
        {
            text: 'Temporário',
            value: 'temporario',
        },
        {
            text: 'Bloqueado',
            value: 'bloqueado',
        },
    ];

    const [lineExpandEmail, setLineExpandEmail] = useState(null);
    const [lineExpandPartner, setLineExpandPartner] = useState(null);

    function getNewFilters(filters) {
        let newFilters = filters;

        if (filterPartner.value) {
            newFilters = { ...newFilters, partner_id: [filterPartner.value] };
        } else {
            delete newFilters["partner_id"];
        }

        if (filterApplication.value) {
            newFilters = { ...newFilters, application_id: [filterApplication.value] };
        } else {
            delete newFilters["application_id"];
        }

        return newFilters;
    }

    const tableColumns = [
        {
            title: <strong>Cód ID</strong>,
            dataIndex: 'id',
            key: 'id',
            width: '8%',
            render: (user) => (
                <strong>{user}</strong>
            ),
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            defaultSortOrder: 'ascend',
            render: (name, user) => (
                <DataName name={name} picture={user.picture} />
            ),
        },
        {
            title: 'CPF',
            dataIndex: 'identification_number',
            key: 'identification_number',
            render: (cpf, user) => (
                <span>{Utils.maskCpf(cpf)}</span>
            ),
        },
        {
            title: 'E-mail',
            dataIndex: 'emails',
            key: 'emails',
            render: (emails, index) => (
                <DataEmails
                    list={emails}
                    line={index}
                    lineExpand={lineExpandEmail}
                    callback={() => handleExpandEmail(index)} />
            )
        },
        {
            title: 'Parceiro',
            dataIndex: 'partners',
            key: 'partners',
            render: (partners, index) => (
                <DataPartners
                    data={removePartnerDefault(partners)}
                    line={index}
                    maxLines={5}
                    lineExpand={lineExpandPartner}
                    callback={() => handleExpandPartner(index)} />
            )
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: filterStatus,
            filterMultiple: false,
            render: (status) => (
                <DataStatus status={status} />
            ),
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            ellipsis: true,
            align: "center",
            render: (text, record, index) => (
                <TableActions>
                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_PERMISSOES)) ?
                        <ButtonAction type="edit" text="Editar permissões" callback={() => handleEditUser(record)} />
                        : null
                    }
                </TableActions>
            ),
        }
    ];

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    useEffect(() => {
        setLineExpandEmail(null);
        setLineExpandPartner(null);

        let newFilters = getNewFilters(filters);
        setFilters(newFilters);

        getUsersOrSearch(pagination, newFilters, sorter, searchUser);
    }, [searchUser, filterPartner, filterApplication]);

    function removePartnerDefault(partners) {
        let array = [];
        if (partners) {
            partners.forEach((partner) => {
                if (partner.id != 1) {
                    array.push(partner)
                }
            })
        }
        return array;
    }

    function getUsersOrSearch(pagination, filters, sorter, search) {
        let filtered = isFiltered(filters);

        if (search === "" && !filtered) {
            getUsers(pagination, sorter);
        } else {
            searchUsers(pagination, filters, sorter, search)
        }
    }

    function getUsers(pagination, sorter) {
        const order = getOrder(sorter);
        const offset = pagination.current;
        const lines = pagination.pageSize;

        setTableLoading(true);
        Http.get(`/users/get-users?offset=${offset}&order=${order}&lines=${lines}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    const paginationDescription = (total) => `Usuários encontrados: ${total}`;
                    setPagination({ ...pagination, total: responseData.pagination, showTotal: paginationDescription });
                    setTableData(formatTable(responseData.data));
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
                setPagination(defaultPagination);
            })
    }

    function searchUsers(pagination, filters, sorter, search) {
        const body = {
            "order": getOrder(sorter),
            "offset": pagination.current,
            "lines": pagination.pageSize,
            "search": search,
            "filters": filters
        };

        setTableLoading(true);
        Http.post(`/users/search-users`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    const paginationDescription = (total) => `Usuários encontrados: ${total}`;
                    setPagination({ ...pagination, total: responseData.pagination, showTotal: paginationDescription });
                    setTableData(formatTable(responseData.data));
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
                setPagination(defaultPagination);
            })
    };

    function formatTable(data) {
        let array = [];
        data.forEach((user) => {
            user.emails = [user.email, ...user.secondary_emails];
            array.push(user)
        })
        return array;
    }

    function isFiltered(filters) {
        let result = false;
        Object.keys(filters).forEach((key) => {
            if (Object.values(filters[key]).length > 0) {
                result = true;
            }
        });
        return result;
    }

    function getOrder(sorter) {
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    }

    function handleExpandEmail(index) {
        index != lineExpandEmail ? setLineExpandEmail(index) : setLineExpandEmail(null);
        setLineExpandPartner(null);
    }

    function handleExpandPartner(index) {
        index != lineExpandPartner ? setLineExpandPartner(index) : setLineExpandPartner(null);
        setLineExpandEmail(null);
    }

    function handleEditUser(user) {
        dispatch(usersSetShowUsers(false));
        dispatch(usersSetShowEditUser(true));
        dispatch(usersSetSelectedUser(user));
    }

    function handleOnChangeTable(paginationTable, filtersTable, sorterTable, currentPageData) {
        const mergedFilters = Object.assign(filters, filtersTable);

        Object.keys(mergedFilters).forEach((key) => {
            if (!mergedFilters[key]) {
                delete mergedFilters[key]
            }
        });

        setSorter(sorterTable);
        setFilters(mergedFilters);
        getUsersOrSearch(paginationTable, mergedFilters, sorterTable, searchUser);
    }

    function handleOnSave() {
        getUsersOrSearch(pagination, filters, sorter, searchUser);
    }

    return (
        <>
            <AccountTable
                columns={tableColumns}
                dataSource={tableData}
                pagination={pagination}
                loading={tableLoading}
                onChange={handleOnChangeTable}
            />
            {showUserModal ? <NewUserModal onSave={handleOnSave} /> : null}
        </>
    )
}

export default CardUsers;
